import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { TextAreaFieldCard } from './styled';
import { ITextareaField } from '../../../../types';

interface OriginalTextareaFieldProps {
  field: ITextareaField;
}

export const OriginalTextareaField: FC<OriginalTextareaFieldProps> = ({
  field
}) => (
  <TextAreaFieldCard>
    <SText
      weight="normal"
      fontColor={TextColor.SlateGrey}
      maxLines={Infinity}
      title={field.data}
      style={{ whiteSpace: 'pre-line' }}
    />
  </TextAreaFieldCard>
);
